// extracted by mini-css-extract-plugin
export default {"root":"Badge_root__u0HLC"};